/**
 * @param {number} value
 * @param {Intl.NumberFormatOptions} config
 * @return {string}
 */
export default function (value, config = {style: 'currency', currency: 'EUR', minimumFractionDigits: 0}) {
    if (isNaN(value) || value === 0) {
        return '';
    }

    return value.toLocaleString(undefined, config);
}


// WEBPACK FOOTER //
// ./assets/js/filters/currency.js